var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "slider") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.54,
    y1: 3,
    x2: 3.54,
    y2: 14.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 3.54,
    cy: 17.39,
    r: 2.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.54,
    y1: 19.93,
    x2: 3.54,
    y2: 23.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 6.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12,
    cy: 8.92,
    r: 2.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12,
    y1: 11.46,
    x2: 12,
    y2: 23.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.46,
    y1: 3,
    x2: 20.46,
    y2: 11.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20.46,
    cy: 14,
    r: 2.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.46,
    y1: 16.54,
    x2: 20.46,
    y2: 23.31
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider01);
export default __webpack_public_path__ + "static/media/slider_01.7261fca792b4ebb4917d5ea86b56b503.svg";
export { ForwardRef as ReactComponent };